module.exports = __webpack_public_path__ + "img/icons.cb3fbe88.svg";